// extracted by mini-css-extract-plugin
export default {"p":"_31c4e1cbb3 _247cc319f6 cb0181ee06","clr":"_58bae9033d","dls":"c5f4308dbd"};